import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

export const fetchMarkets = createAsyncThunk(
  'markets/fetchMarkets',
  async (params = {}) => {
    const response = await api.get('/api/markets/', { params });
    
    // Handle paginated response (DRF pagination)
    if (response.data && response.data.results && Array.isArray(response.data.results)) {
      return response.data.results;
    }
    
    // Handle non-paginated response (fallback)
    if (Array.isArray(response.data)) {
      return response.data;
    }
    
    // If unexpected format, return empty array to prevent crashes
    console.error('Unexpected response format from /api/markets/:', response.data);
    return [];
  }
);

export const createMarket = createAsyncThunk(
  'markets/createMarket',
  async (marketData) => {
    const response = await api.post('/api/markets/', marketData);
    return response.data;
  }
);

export const createMultipleMarkets = createAsyncThunk(
  'markets/createMultiple',
  async (marketsData) => {
    // Create markets one by one
    const results = await Promise.all(
      marketsData.map(data => api.post('/api/markets/', data))
    );
    return results.map(r => r.data);
  }
);

const marketSlice = createSlice({
  name: 'markets',
  initialState: {
    markets: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMarkets.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMarkets.fulfilled, (state, action) => {
        state.loading = false;
        state.markets = action.payload;
      })
      .addCase(fetchMarkets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createMarket.fulfilled, (state, action) => {
        state.markets.push(action.payload);
      })
      .addCase(createMultipleMarkets.fulfilled, (state, action) => {
        state.markets.push(...action.payload);
      });
  },
});

export default marketSlice.reducer;